export const Instagram = 'https://www.instagram.com/kevinchrisweber';
export const WhatsApp = 'https://chat.whatsapp.com/GnlhBystnB3CaJxYA0e8eM';
export const Strava = 'https://www.strava.com/clubs/1995325';